module.exports = __webpack_public_path__ + "static/media/magic-link-lock-error.a48b3de4.svg";